export default Object.freeze({
  Pendiente: 1,
  Aprobado: 2,
  Denegado: 3,
  Revision: 5,
  NoGeneraPago: 6,
  Pagado: 7,
});
